
import React from "react"
import { FormattedMessage } from "react-intl"
import LinkWrapper from "../../../../common/rich-text/feature-protection-wrappers/linkWrapper.component"
import Icon from "../../../icon/icon.component.jsx"


const CalendarEventCreationButton = () => {
    return (
        <>
            <LinkWrapper
                to={"/calendar-events/new"}
                className={"btn btn-primary"}
                protectedClassName={"btn btn-primary"}
                premium={false}
                protectionRule={true}>
                <span>
                    <Icon value={"plus-circle"} />
                    <FormattedMessage
                        id="listing.search.calendar_event_add_btn"
                        defaultMessage="New event"
                    />
                </span>
            </LinkWrapper>
        </>
    )
}

export default CalendarEventCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/CalendarEventCreationButton.tsx